// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","moveToTop":"MoveToTop-module__moveToTop--dq"};